import {
  StyleSheet,
  ImageBackground,
  Image,
  SafeAreaView,
  useWindowDimensions,
} from "react-native";
import React from "react";
import {
  View,
  ScrollView,
  Text,
  Heading,
  Pressable,
  Box,
  Center,
  VStack,
} from "native-base";
import { StackScreenProps } from "../../types";
import { LinearGradient } from "expo-linear-gradient";
import Header from "../../components/Header";

const CSR = ({ navigation }: StackScreenProps<"CSR">) => {
  const { width, height } = useWindowDimensions();
  const images = [
    {
      img: require("../../assets/football_team.png"),
      title: "Nigerian Football League",
      desc: ["Sponsorship of Nigerian League for two(2) seasons."],
    },
    {
      img: require("../../assets/ksu.png"),
      title: "Kaduna State University",
      desc: [
        "--	Scholarship to 12 students of Faculty of Agriculture",
        "--	Grant to Faculty of Agriculture",
        "--	Laboratory Equipment to Department of Soil Science",
        "--	Support for Soybean trials",
      ],
    },
    {
      img: require("../../assets/uniabuja.png"),
      title: "University of Abuja",
      desc: [
        "Advanced support to obtain grant for development of Centre of Competence in Digital Education sponsored by UM6P and EPFL Netherland.",
      ],
    },
    {
      img: require("../../assets/akwaibom.png"),
      title: "Akwa Ibom State University",
      desc: [
        "-- Supply of books to the Faculty of Agriculture.",
        "-- Research grant",
        "-- Annual scholarship to 15 students in Department of Crop and Soil Science.",
      ],
    },
    {
      img: require("../../assets/bauchi.png"),
      title: "BauchI State University",
      desc: [
        "Partnership in training of young entrepreneurs for EMAY Project.",
      ],
    },
  ];
  return (
    <ImageBackground
      source={require("../../assets/csr_bgd.png")}
      resizeMode="cover"
      style={{ width, height }}
    >
      <LinearGradient
        colors={[
          "rgba(11, 46, 89, 1)",
          "rgba(0, 0, 0, 0)",
          "rgba(41, 124, 224, 1)",
        ]}
        style={styles.overlay}
      >
        <SafeAreaView style={{ height }}>
          <ScrollView px={5}>
            <Header
              onPress={() => navigation.navigate("PublicPartnerships")}
              parentText="Public Partnerships"
              headingText="CSR"
            />

            <ScrollView mt={5} showsHorizontalScrollIndicator={false}>
              {images.map((item, i) => (
                <Box w={320} h={350} margin="auto" mb={5} key={i}>
                  <ImageBackground
                    source={item.img}
                    style={{
                      width: 320,
                      height: 350,
                      borderRadius: 35,
                      overflow: "hidden",
                      borderWidth: 5,
                      borderColor: "white",
                    }}
                    imageStyle={{
                      borderRadius: 15,
                      backgroundColor: "rgba(0,0,0,.8)",
                    }}
                  >
                    <VStack
                      style={styles.cardOverlay}
                      alignContent="center"
                      justifyContent={"space-between"}
                      p={5}
                    >
                      <Heading size={"sm"} textAlign="center">
                        {item?.title}
                      </Heading>
                      <View>
                        {item.desc?.map((d) => (
                          <Text key={d}>{d || ""}</Text>
                        ))}
                      </View>
                    </VStack>
                  </ImageBackground>
                </Box>
              ))}
            </ScrollView>
          </ScrollView>
        </SafeAreaView>
      </LinearGradient>
    </ImageBackground>
  );
};

export default CSR;

const styles = StyleSheet.create({
  overlay: {
    ...StyleSheet.absoluteFillObject,
    // backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
  cardOverlay: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0, 0, 0, 0.1)",
  },
});
